import classnames from 'classnames';
import { Program, ProgramV2 } from 'frontend/types';
import { formatTime } from 'frontend/utils/timeUtils';
import { createPortal } from 'react-dom';
import CloseIcon from 'assets/icons/close-white.svg';
import styles from './Chapters.module.css';
import useChapters from 'frontend/utils/hooks/useChapters';
import useKeys from 'frontend/utils/hooks/useKeys';
import { KeyCodes } from 'frontend/enums';
export interface Chapter {
  time: number;
  title: {
    sv: string;
  };
}
export const CHAPTER_CONTAINER_ID = 'chapter-container';
const pushToDataLayer = (chapter: Chapter, currentProgram: Program | ProgramV2) => {
  window.dataLayer?.push({
    event: 'Chapter select',
    chapter_title: chapter.title.sv,
    chapter_time: chapter.time,
    media_format: currentProgram.format,
    program_id: currentProgram.id,
    program_name: currentProgram.title,
    series_name: currentProgram.series?.title,
    series_id: currentProgram.series?.id,
    typical_age_range_translations: currentProgram.typicalAgeRangeTranslations
  });
};
const Chapters = ({
  player,
  isFullScreen,
  fullscreenContainer,
  chapters,
  isOpened,
  closeButtonCallback,
  currentProgram
}: {
  player: jwplayer.JWPlayer | null;
  isFullScreen: boolean;
  fullscreenContainer: HTMLDivElement;
  chapters: Chapter[];
  isOpened: boolean;
  closeButtonCallback: () => void;
  currentProgram: Program | ProgramV2;
}) => {
  const currentChapter = useChapters(player, chapters);
  useKeys(isOpened, {
    [KeyCodes.ESCAPE_KEY]: closeButtonCallback
  });
  const playerSeek = (seconds: number) => {
    player?.seek(seconds);
  };
  const chapterContainer = chapters.length > 0 ? <div className={classnames(styles.chaptersContainer, {
    [`${styles.fullScreen}`]: isFullScreen,
    [`${styles.isOpened}`]: isOpened
  })} id={CHAPTER_CONTAINER_ID} data-testid={CHAPTER_CONTAINER_ID}>
        <div className={styles.chapterHeading}>
          <span>Kapitel</span>
          <button aria-label="Stäng kapitelmenyn" className={styles.closeButton} onClick={() => {
        closeButtonCallback();
      }}>
            <CloseIcon aria-hidden />
          </button>
        </div>
        <ul className={classnames(styles.chapterList, {
      [`${styles.fullScreen}`]: isFullScreen
    })}>
          {chapters.map((c, index) => {
        const isCurrentChapter = c.time === currentChapter?.time;
        const isLastIndex = chapters.length - 1 === index;
        const closeOnTabForward = {
          onKeyDown: e => {
            if (e.key === KeyCodes.TAB_KEY && !e.shiftKey) closeButtonCallback();
          }
        };
        return <li className={styles.chapter} key={c.time}>
                <button className={classnames(styles.chapterButton, {
            [`${styles.active}`]: isCurrentChapter
          })} onClick={() => {
            playerSeek(c.time);
            pushToDataLayer(c, currentProgram);
          }} {...isLastIndex && closeOnTabForward}>
                  <div className={styles.chapterTitleAndTime}>
                    <span className={styles.chapterTitle}>{c.title.sv}</span>
                    <span>{formatTime(c.time)}</span>
                  </div>
                </button>
              </li>;
      })}
        </ul>
      </div> : null;
  return isFullScreen ? createPortal(chapterContainer, fullscreenContainer) : chapterContainer;
};
export default Chapters;